<template>
  <DefaultTemplate format="center">
    <Forgot/>
  </DefaultTemplate>
</template>

<script>
import DefaultTemplate from '@/template/DefaultTemplate'
import Forgot from '@/components/ForgotPassword'

export default {

  data () {
    return {
     
    }
  },
  components:{
      DefaultTemplate,
      Forgot,
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/ForgotPassword.vue